import script from "./SelectComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectComponent.vue?vue&type=script&setup=true&lang=js"

import "./SelectComponent.vue?vue&type=style&index=0&id=6f11c632&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f11c632"]])

export default __exports__